(function($) {
  $(document).ready(function() {

    if ($.fn.select2) {

      $(".select2-filter").select2({
        minimumResultsForSearch: 7
      });

      $(".select2-filter").on("select2:open", function() {
        $(".select2-search--dropdown .select2-search__field").attr("placeholder", "Typ om te zoeken...");
      });
      $(".select2-filter").on("select2:close", function() {
        //$(".select2-search--dropdown .select2-search__field").attr("placeholder", null);
      });

    }

    if ($.fn.chosen) {

      // Use chosen instead
      $(".chosen-filter").chosen({
        disable_search_threshold: 5
      });

    }

    if ($.fn.selectize) {

      // Or use selectize
      $(".filter-search").selectize({});

    }

  });
})(jQuery);
